<template>
    <div :data-component="$options.name">
        <ms-lightbox
            :visible="isVisible"
            @update:visible="emitClosedLightboxEvent"
        >
            <template #content>
                <iframe
                    :src="iFrameUrl"
                    allowfullscreen
                    class="h-full w-full px-16 pt-56 pb-16"
                >
                </iframe>
            </template>
        </ms-lightbox>
    </div>
</template>
<script lang="ts" src="./MsDetailThreeSixtyLightbox.ts" />
